import React from 'react';
import { ReactComponent as ExclamationMarkOrange } from 'app/assets/icons/exclamationMarkOrange.svg';

interface IComponentProps {
  text: string;
}

export const WarningNotification: React.FC<IComponentProps> = ({ text }) => {
  return (
    <div className='warning-notification__wrapper'>
      <ExclamationMarkOrange />
      <span className='ml-2'>{text}</span>
    </div>
  );
};
